import request from '@/utils/request'

export function findModuleInventories(params) {
  return request({
    url: `/module_inventories`,
    method: 'get',
    params
  })
}

// 模组入库
export function importModuleInventories(data) {
  return request({
    url: `/module_inventories/import`,
    method: 'post',
    data
  })
}

// 模组重新入库
export function reImportModuleInventories(data) {
  return request({
    url: `/module_inventories/re_import`,
    method: 'post',
    data
  })
}

// 导出库存模组
export function exportModuleInventories(data) {
  return request({
    url: `/module_inventories/export`,
    method: 'post',
    data
  })
}
